import Swiper, { Navigation, Thumbs, FreeMode } from "swiper";

export default class Carousel {
  constructor() {
    this.init();
  }

  public init = () => {
    // 全ての ".js-swiper" クラスを持つ要素に対してループ
    document.querySelectorAll(".js-swiper").forEach((swiperElement, index) => {
      const swiperIndex = index + 1;

      // サムネイルスライダーの初期化
      const sliderThumbnail = new Swiper(
        `.js-swiper-thumbnail-${swiperIndex}`,
        {
          slidesPerView: 5, // サムネイル表示枚数
          freeMode: true, // フリーモード（スワイプで自由に動く）
          watchSlidesProgress: true, // スライドの進捗を監視
          spaceBetween: 10, // スライド間のスペース
          modules: [FreeMode], // FreeModeモジュールを使用
        }
      );

      // メインスライダーの初期化
      const slider = new Swiper(`.js-swiper-main-${swiperIndex}`, {
        loop: true, // ループを有効にする
        loopAdditionalSlides: 1, // 追加のスライドを設定し、ループがスムーズに行くようにする
        slidesPerView: 1, // 表示するスライド数
        speed: 600, // アニメーションのスピード

        navigation: {
          nextEl: `.swiper-button-next-${swiperIndex}`, // 次へボタンのセレクタ
          prevEl: `.swiper-button-prev-${swiperIndex}`, // 前へボタンのセレクタ
        },

        thumbs: {
          swiper: sliderThumbnail, // サムネイルスライダーをメインにリンクさせる
        },
        modules: [Navigation, Thumbs], // 必要なモジュールを追加
      });
    });
  };
}
